<div id="summary" class="registration container">
  <form #summaryForm="ngForm" name="summaryForm" (ngSubmit)="forward(summaryForm)" novalidate appScrollToInvalid [ngClass]="{'form-complete': isFormCompleted }" *ngIf="!errorMsg">
    <div class="card emptybody" *ngIf="!errorMsg && !successMessage && isRegComplete">
      <div class="card-title">
        <div class="summaryHeaderAndPrint">
          <h1>{{ 'copy.label.SUMMARY.heading' | copy | async }}</h1>
          <mat-icon class="printButton" (click)="printPage();" aria-hidden="false" aria-label="Example home icon">print</mat-icon>
        </div>
      </div>
    </div>
    <div class="card" *ngIf="errorMsg || successMessage || !isRegComplete">
      <div class="card-title">
        <div class="summaryHeaderAndPrint">
          <h1>{{ 'copy.label.SUMMARY.heading' | copy | async }}</h1>
          <mat-icon class="printButton" (click)="printPage();" aria-hidden="false" aria-label="Example home icon">print</mat-icon>
        </div>
      </div>
      <div class="card-body" >
        <!-- Top Section -->
        <div class="w-100" *ngIf="errorMsg" type="danger">
          <strong>
            <span class="fas fa-stack">
              <i class="fas fa-exclamation fa-stack-1x"></i>
              <i class="far fa-circle fa-stack-2x"></i></span> {{errorMsg}}</strong>
        </div>
        <div class="w-100" *ngIf="successMessage">
          <div class="w-100" [innerHTML]='"copy.html.rvsSuccessMessage"|copy|async'></div>
        </div>
        <section *ngIf="!isRegComplete">
          <h2>{{ 'copy.label.SUMMARY.review' | copy | async }}</h2>
          <article name="legal" class="summaryLinks">
            <div class="agreeCheckbox">
              <div class="checkboxFlexContainer">
                <mat-checkbox name="termsAndConditions" [(ngModel)]="enrollment.AgreedToTermsAndConditions" #termsAndConditions="ngModel" required></mat-checkbox>
                <!-- Placing the text inside the mat-checkbox will make it so the checkbox will be checked when links are clicked --><label class="required">
                  I agree to the Maritz <a tabindex="0" (click)="openModal('termsOfUse', 'About This Site', 'Close');" (keydown.enter)="openModal('termsOfUse', 'About This Site', 'Close');">Terms of Use</a> and
                  the <a tabindex="0" (click)="openModal('ResponsibilityStatement', 'Responsibility Statement', 'Close');" (keydown.enter)="openModal('ResponsibilityStatement', 'Responsibility Statement', 'Close');">{{ 'copy.label.SUMMARY.responsibilitylink' | copy | async }}</a></label>
              </div>
              <div class="w-100">
                <small class="text-danger"><app-validation [object]="termsAndConditions" isRequired=true></app-validation></small>
              </div>
            </div>
            <div *ngIf="isGDPR">
              <div class="agreeCheckbox">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="privacyPolicy" [(ngModel)]="enrollment.PrivacyPolicy"></mat-checkbox>
                  <!-- Placing the text inside the mat-checkbox will make it so the checkbox will be checked when links are clicked -->
                  <label>I agree to the <a href="https://www.ford.com/help/privacy/" target="_blank">Privacy Policy</a>. I
                    understand that Maritz may collect and process my personal information on behalf of {{'clientName' |copy |async}}.</label>
                </div>
              </div>
            </div>
            <!--div class="agreeCheckbox">
              <div class="checkboxFlexContainer">
                <mat-checkbox name="rememberme" [(ngModel)]="rememberme" #RememberMe="ngModel"></mat-checkbox>
                <label>{{"copy.label.SUMMARY.rememberme"|copy|async}}
                  <a tabindex="0" matTooltip="{{'copy.label.SUMMARY.remembermequestion'|copy|async}}">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </a></label>
              </div>
            </div-->

            <!-- Code of conduct-->
        <!--     <div class="bg-super-light rounded p-3 mt-2"  *ngIf="attendee.PAXTypeNo != 3">
              <u><p><strong>{{ 'copy.html.policies.codeConduct.header' | copy | async }}</strong></p></u>
              <div [innerHTML]="'copy.html.policies.codeConduct.note' | copy | async"></div>
              <div class="agreeCheckbox">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="codeConduct" [ngModel]="givemePolicyBox('codeConduct')" #codeConduct="ngModel" (ngModelChange)="policyChange('codeConduct',$event)" required></mat-checkbox>
                  <label  class="required"> {{ 'copy.html.policies.codeConduct.checkbox' | copy | async }}</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="codeConduct" isRequired=true></app-validation></small>
                </div>
              </div>
            </div> -->

            <!-- Cancellation Policy-->
         <!--    <div class="bg-super-light rounded p-3 mt-2 summary-element" *ngIf="attendee.PAXTypeNo != 3">
              <u><p><strong>{{ 'copy.html.policies.cancelPolicy.header' | copy | async }}</strong></p></u>
              <div [innerHTML]="'copy.html.policies.cancelPolicy.note' | copy | async"></div>
              <div class="agreeCheckbox">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="cancelPolicy" [ngModel]="givemePolicyBox('cancelPolicy')" #cancelPolicy="ngModel" (ngModelChange)="policyChange('cancelPolicy',$event)" required></mat-checkbox>
                  <label  class="required"> {{ 'copy.html.policies.cancelPolicy.checkbox' | copy | async }}</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="cancelPolicy" isRequired=true></app-validation></small>
                </div>
              </div>
            </div> -->

            <!-- Photo Release Policy-->
      <!--       <div class="bg-super-light rounded p-3 mt-2 summary-element" *ngIf="attendee.PAXTypeNo != 3">
              <u><p><strong>{{ 'copy.html.policies.photoRelease.header' | copy | async }}</strong></p></u>
              <div [innerHTML]="'copy.html.policies.photoRelease.note' | copy | async"></div>
              <div class="agreeCheckbox mt-2">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="photoPolicy" [ngModel]="givemePolicyBox('photoRelease')" #photoPolicy="ngModel" (ngModelChange)="policyChange('photoRelease',$event)" required></mat-checkbox>
                  <label  class="required"> {{ 'copy.html.policies.photoRelease.checkbox' | copy | async }}</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="photoPolicy" isRequired=true></app-validation></small>
                </div>
              </div>
            </div> -->

            <!-- 1099 Policy-->
        <!--     <div class="bg-super-light rounded p-3 mt-2 summary-element" *ngIf="attendee.PAXTypeNo != 3">
              <u><p><strong>{{ 'copy.html.1099.header' | copy | async }}</strong></p></u>
              <div [innerHTML]="'copy.html.1099.text' | copy | async"></div>
              <div class="agreeCheckbox mt-2">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="l099Policy" [ngModel]="givemePolicyBox('l099')" #l099Policy="ngModel" (ngModelChange)="policyChange('l099',$event)" required></mat-checkbox>
                  <label  class="required"> {{ 'copy.html.1099.check' | copy | async }}</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="l099Policy" isRequired=true></app-validation></small>
                </div>
              </div>
            </div> -->

            <!-- Real ID Policy-->
           <!--  <div class="bg-super-light rounded p-3 mt-2 summary-element" *ngIf="attendee.PAXTypeNo != 3">
              <u><p><strong>{{ 'copy.html.Summ_RealID_Check.header' | copy | async }}</strong></p></u>
              <div [innerHTML]="'copy.html.Summ_RealID_Check.text' | copy | async"></div>
              <div class="agreeCheckbox mt-2">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="realIDPolicy" [ngModel]="givemePolicyBox('realID')" #realIDPolicy="ngModel" (ngModelChange)="policyChange('realID',$event)" required></mat-checkbox>
                  <label [innerHTML]="'copy.html.Summ_RealID_Check.check' | copy | async" class="required"> </label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="realIDPolicy" isRequired=true></app-validation></small>
                </div>
              </div>
            </div> -->

          </article>
        </section>
      </div>
    </div>
    <!-- Attendee Page -->
    <mat-expansion-panel *ngIf="siteFlowContains('attendee')" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{attendee.$mtcDisplayName}}
          <a class="edit-link" tabindex="0" *ngIf="!isRegComplete" (click)="editAttendee()" (keydown.enter)="editAttendee()">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
          <a class="edit-link" tabindex="0" *ngIf="isRegComplete" (click)="editAttendee()" (keydown.enter)="editAttendee()">{{ 'copy.label.SUMMARY.editlocked'| copy | async }}</a>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-badge></app-badge>
      
      <!--app-summary-display [ngmodel]="dealerCode.Value" *ngIf="attendee.PAXTypeNo===1 || attendee.PAXTypeNo === 4">{{ 'copy.label.ATTENDEE.EMPLOYMENT.dealer_code' | copy | async }}
      </app-summary-display-->
      <app-summary-display [ngmodel]="partsAccountNum.Value" *ngIf="attendee.PAXTypeNo === 3 && partsAccountNum.Value !== undefined">{{ 'copy.label.ATTENDEE.EMPLOYMENT.code' | copy | async }}
      </app-summary-display>
      <!--app-summary-display [ngmodel]="starsID.Value" *ngIf="attendee.PAXTypeNo===1 || attendee.PAXTypeNo === 4">{{ 'copy.label.ATTENDEE.EMPLOYMENT.id' | copy | async }}
      </app-summary-display-->

      <!--app-summary-display [ngmodel]="this.attendee.BirthDate| date:'longDate'">
        {{'copy.label.TRAVEL.birthdate' | copy | async }}</app-summary-display -->
      <app-addresssummary *ngIf="workAddress.AddressLine1 !== undefined" [address]="workAddress">
        {{ 'copy.label.FEATURES.ADDRESS.business' | copy | async }}</app-addresssummary>
      <app-addresssummary *ngIf="homeAddress.AddressLine1 !== undefined" [address]="homeAddress">
        {{ 'copy.label.FEATURES.ADDRESS.home' | copy | async }}</app-addresssummary>
      <app-summary-display [ngmodel]="emailAddress.EmailAddress">{{ 'copy.label.FEATURES.EMAIL.label' | copy | async }}
      </app-summary-display>
      <app-phonesummary *ngIf="workPhone.PhoneNo !== '' && workPhone.PhoneNo !== undefined" [phone]="workPhone">
        {{ 'copy.label.ATTENDEE.CONTACT.bizphonelabel' | copy | async }}</app-phonesummary>
      <app-phonesummary *ngIf="mobilePhone.PhoneNo !== '' && mobilePhone.PhoneNo !== undefined" [phone]="mobilePhone">
        {{ 'copy.label.ATTENDEE.CONTACT.cellphonelabel' | copy | async }}</app-phonesummary>
      <app-phonesummary *ngIf="homePhone.PhoneNo !== '' && homePhone.PhoneNo !== undefined" [phone]="homePhone">
        {{ 'copy.label.ATTENDEE.CONTACT.homephonelabel' | copy | async }}</app-phonesummary>
      <app-summary-display *ngIf="attendee.PAXTypeNo != 7" [ngmodel]="attendee.EmergencyContact.EmergencyContactName">
        {{ 'copy.label.FEATURES.EMERGENCY.namelabel' | copy | async }}</app-summary-display>
      <app-summary-display *ngIf="attendee.PAXTypeNo != 7" [ngmodel]="attendee.EmergencyContact.EmergencyContactRelation">
        {{ 'copy.label.FEATURES.EMERGENCY.relationshiplabel' | copy | async }}</app-summary-display>
      <app-phonesummary *ngIf="emerContactMainPhone.PhoneNo !== '' && emerContactMainPhone.PhoneNo !== undefined" [phone]="emerContactMainPhone">{{ 'copy.label.FEATURES.EMERGENCY.phonelabel' | copy | async }}
      </app-phonesummary>
      <app-phonesummary *ngIf="emerContactAltPhone.PhoneNo !== '' && emerContactAltPhone.PhoneNo !== undefined" [phone]="emerContactAltPhone">{{ 'copy.label.FEATURES.EMERGENCY.altphonelabel' | copy | async }}
      </app-phonesummary>
      <!-- Dietary Considerations -->
      <!-- <div class="mainAttendeeConsiderations" *ngIf="!attendee.$mtcHasConsiderations">
        <div *ngIf="!attendee.$mtcHasConsiderations" class="form-summary">
          <label class="col-md-6 col-xs-12">{{ 'copy.label.ATTENDEE.DIETARY.header' | copy | async }}</label>
          <span class="form-summary-item col-md-6 col-xs-12">{{ 'copy.label.FEATURES.PERSONAL.nopersonal' | copy | async }}</span>
        </div>
      </div> -->
      <div class="mainAttendeeConsiderations" >
        <div *ngIf="attendee.DietaryNeed || attendee.DietaryConsiderations" class="form-summary">
          <label class="col-md-6 col-xs-12">{{ 'copy.label.FEATURES.DIETARY.label' | copy | async }}</label>
          <span class="form-summary-item col-md-6 col-xs-12" *ngIf="!attendee.DietaryConsiderations">{{dietaryNeedDisplay}}</span>
          <span class="form-summary-item col-md-6 col-xs-12" *ngIf="attendee.DietaryConsiderations">{{dietaryNeedDisplay}}<span *ngIf="attendee.DietaryNeed" >-</span>{{attendee.DietaryConsiderations}} </span>
        </div>
        <app-summary-display [ngmodel]="personalConsiderationsDisplay" *ngIf="checkDisabilityType(this.attendee)">
          {{ 'copy.label.FEATURES.PERSONAL.ADAsummary' | copy | async }}</app-summary-display>
      </div>
      <div *ngIf="enrollment.$mtcHasAdminContact">
        <app-summary-display [ngmodel]="adminContact.AdminContactName">
          {{ 'copy.label.FEATURES.ADMIN.namelabel' | copy | async }}</app-summary-display>
        <app-phonesummary *ngIf="enrollment.$mtcHasAdminContact" [phone]="adminContact.AdminContactPhone[0]">{{ 'copy.label.FEATURES.ADMIN.phonelabel' | copy | async }}
        </app-phonesummary>
        <app-summary-display [ngmodel]="adminContact.AdminContactEmailAddress">
          {{ 'copy.label.FEATURES.ADMIN.email' | copy | async }}</app-summary-display>
      </div>
    </mat-expansion-panel>
    <!-- Guest Page -->
    <div *ngIf="siteFlowContains('guest')">
      <mat-expansion-panel *ngIf="!guests.length" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Guest
            <a class="edit-link" tabindex="0" *ngIf="!isRegComplete" (click)="editGuest(undefined)" (keydown.enter)="editGuest(undefined)">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
            <a class="edit-link" tabindex="0" *ngIf="isRegComplete" (click)="editTravel()" (keydown.enter)="editTravel()">{{ 'copy.label.SUMMARY.editlocked'| copy | async }}</a>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-summary">
          <label class="col-md-6 col-xs-12">{{"copy.label.SUMMARY.noguest"|copy|async}}</label>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel *ngFor="let guest of guests" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{guest.$mtcDisplayName}}
            <a class="edit-link" tabindex="0" *ngIf="!isRegComplete" (click)="editGuest(guest)" (keydown.enter)="editGuest(guest)">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
            <a class="edit-link" tabindex="0" *ngIf="isRegComplete" (click)="editGuest(guest)" (keydown.enter)="editGuest(guest)">{{ 'copy.label.SUMMARY.editlocked'| copy | async }}</a>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-summary-display [ngmodel]="guest.PreferredFirstName" *ngIf="guest.PreferredFirstName">
          {{ 'copy.label.FEATURES.NAME.preferredfirst' | copy | async }}</app-summary-display>
        <app-summary-display [ngmodel]="guest.PreferredLastName" *ngIf="guest.PreferredLastName">
          {{ 'copy.label.FEATURES.NAME.preferredlast' | copy | async }}</app-summary-display>
        <app-summary-display [ngmodel]="getGuestTypeDisplay(guest)">
          {{ 'copy.label.FEATURES.GUESTTYPE.heading' | copy | async }}</app-summary-display>
        <!-- <div class="guestConsiderations">
          <div *ngIf="!guest.$mtcHasConsiderations" class="form-summary">
            <label class="col-md-6 col-xs-12">{{ 'copy.label.ATTENDEE.DIETARY.header' | copy | async }}</label>
            <span class="form-summary-item col-md-6 col-xs-12">{{ 'copy.label.FEATURES.PERSONAL.nopersonal' | copy | async }}</span>
          </div>
        </div> -->
        <div class="guestConsiderations">
          <div *ngIf="guest.DietaryNeed || guest.DietaryConsiderations" class="form-summary">
            <label class="col-md-6 col-xs-12">{{ 'copy.label.FEATURES.DIETARY.label' | copy | async }}</label>
            <span class="form-summary-item col-md-6 col-xs-12" *ngIf="!guest.DietaryConsiderations">{{getGuestDiet(guest)}}</span>
            <span class="form-summary-item col-md-6 col-xs-12" *ngIf="guest.DietaryConsiderations">{{getGuestDiet(guest)}} <span *ngIf="guest.DietaryNeed" >-</span> {{guest.DietaryConsiderations}} </span>
          </div>
          <app-summary-display [ngmodel]="getGuestADAPersonal(guest)" *ngIf="checkDisabilityType(guest)">
            {{ 'copy.label.FEATURES.PERSONAL.ADAsummary' | copy | async }}</app-summary-display>
        </div>
      </mat-expansion-panel>
    </div>
    <!-- Demographics Page -->
    <mat-expansion-panel *ngIf="siteFlowContains('demographics')" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Demographics
          <a class="edit-link" tabindex="0" (click)="editDemographics()" (keydown.enter)="editDemographics()">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-summary-display [ngmodel]="shirtSize.Value" *ngIf="shirtSize.Value">
        {{'copy.label.DEMOGRAPHICS.shirtsizelabel' | copy | async}}</app-summary-display>
      <app-summary-display [ngmodel]="firstTime.Value" *ngIf="firstTime.Value">
        {{'copy.label.DEMOGRAPHICS.firsttime'|copy|async}}</app-summary-display>
      <app-summary-display [ngmodel]="whyAttend.Value" *ngIf="whyAttend.Value">
        {{'copy.label.DEMOGRAPHICS.whyAttend' | copy | async }}</app-summary-display>
      <app-summary-display [ngmodel]="bestFeatures.Value" *ngIf="bestFeatures.Value">
        {{'copy.label.DEMOGRAPHICS.bestfeature' | copy | async }}</app-summary-display>
    </mat-expansion-panel>
    <!-- Hotel Page -->
    <mat-expansion-panel *ngIf="siteFlowContains('hotel') || siteFlowContains('hotelbooking') || siteFlowContains('hotelpackage')" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Hotel
          <a class="edit-link" tabindex="0" *ngIf="!hotelList.locked && !this.isRegComplete" (click)="editHotel()" (keydown.enter)="editHotel()">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
          <a class="edit-link" tabindex="0" *ngIf="hotelList.locked || this.isRegComplete" (click)="editHotel()" (keydown.enter)="editHotel()">{{ 'copy.label.SUMMARY.editlocked'| copy | async }}</a>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <span class="form-summary" *ngIf="!enrollment.HotelNeeded">{{ 'copy.label.HOTEL.nohotel'| copy | async }}</span>
      <div *ngIf="siteFlowContains('hotelpackage') && enrollment.HotelNeeded && hotelsLoaded">
        <div *ngFor="let hotelobj of getHotelsWithStays()">
          <span class="form-summary-item">
            <label class="summaryHeader"><strong>{{hotelobj.supplierName}}</strong></label>
            <div class="form-summary">
              <span class="form-summary-item">
                <div class="form-summary-line" *ngFor="let date of getNightsAtHotel(hotelobj.webHotelGroupID)">
                  <strong>{{date| date:'fullDate':"-0500"}} - {{getStatus(hotelobj, date)}}</strong>
                </div>
              </span>
            </div>
          </span>
        </div>
      </div>
      <div *ngIf="siteFlowContains('hotelbooking') && enrollment.HotelNeeded && hotelsLoaded">
        <div *ngFor="let hotelobj of getHotelsWithStays()">
          <span class="form-summary-item">
            <label class="summaryHeader"><strong>{{hotelobj.supplierName}}</strong></label>
            <div class="form-summary">
              <span class="form-summary-item">
                <div class="form-summary-line" *ngFor="let date of getNightsAtHotel(hotelobj.webHotelGroupID)">
                  <strong>{{date| date:'fullDate':"-0500"}} - {{getStatus(hotelobj, date)}}</strong>
                </div>
              </span>
            </div>
          </span>
        </div>
      </div>
       <app-summary-display [ngmodel]="accepRom.Value" *ngIf="attendee.PAXTypeNo === 4">{{'copy.label.HOTEL.government' | copy | async }}</app-summary-display>
      <div *ngIf="siteFlowContains('hotel') && enrollment.HotelNeeded">
          <app-summary-display  [ngmodel]="respHotel.Value" *ngIf="attendee.PAXTypeNo === 4 && accepRom.Value === 'No' && enrollment.HotelNeeded === true">{{'copy.label.HOTEL.responsible' | copy | async }}
          </app-summary-display>
        <app-summary-display [ngmodel]="this.enrollment.HotelCheckInDate| date:'fullDate'">
          {{'copy.label.FEATURES.HOTELPREF.checkin' | copy | async }}</app-summary-display>
        <app-summary-display [ngmodel]="this.enrollment.HotelCheckOutDate| date:'fullDate'">
          {{'copy.label.FEATURES.HOTELPREF.checkout' | copy | async }}</app-summary-display>
      </div>
      
    
    </mat-expansion-panel>
    <!-- Travel Page -->
    <mat-expansion-panel *ngIf="siteFlowContains('travel')" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Travel Request - {{attendee.$mtcDisplayName}} <a class="edit-link" tabindex="0" *ngIf="!isRegComplete" (click)="editTravel()" (keydown.enter)="editTravel()">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
          <a class="edit-link" tabindex="0" *ngIf="isRegComplete" (click)="editTravel()" (keydown.enter)="editTravel()">{{ 'copy.label.SUMMARY.editlocked'| copy | async }}</a>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="form-summary" *ngIf="attendee.TravelType === this.Constants.TRAVEL_TYPES.PRE_REG">
        <label class="col-md-6 col-xs-12">{{ 'copy.label.SUMMARY.alreadybooked'| copy | async }}</label>
      </div>
      <div class="form-summary" *ngIf="attendee.TravelType === this.Constants.TRAVEL_TYPES.DRIVE">
        <label class="col-md-6 col-xs-12">{{ 'copy.label.SUMMARY.drive'| copy | async }}</label>
      </div>
      <app-summary-display [ngmodel]="accepAir.Value" *ngIf="attendee.PAXTypeNo === 4">{{'copy.label.TRAVEL.Government.title' | copy | async }}</app-summary-display>
      <app-summary-display  [ngmodel]="respAir.Value" *ngIf="attendee.PAXTypeNo==4 && accepAir.Value=='No' && attendee.TravelType === this.Constants.TRAVEL_TYPES.FLY ">{{'copy.label.TRAVEL.Government.checkBox' | copy | async }}
      </app-summary-display>

      <div class="form-summary" *ngIf="attendee.TravelType === this.Constants.TRAVEL_TYPES.OWN_AIR" [innerHTML]='"copy.html.ownair" | copy | async'>
      </div>
      <div *ngIf="attendee.TravelType === this.Constants.TRAVEL_TYPES.FLY && isRegComplete" [innerHTML]="'copy.html.RvsMtcAir' |copy |async | safeHtml">
      </div>
      <app-flightsummary *ngIf="attendee.TravelType === this.Constants.TRAVEL_TYPES.FLY && !isRegComplete" [attendee]="attendee" [enrollment]="enrollment" [traveltype]="'FLY'"></app-flightsummary>
      <app-flightsummary *ngIf="attendee.TravelType === this.Constants.TRAVEL_TYPES.RAIL && !isRegComplete" [attendee]="attendee" [enrollment]="enrollment" [traveltype]="'RAIL'"></app-flightsummary>
    </mat-expansion-panel>
    <div *ngIf="siteFlowContains('guest-travel') && attendee.TravelType === this.Constants.TRAVEL_TYPES.FLY">
      <mat-expansion-panel [expanded]="true" *ngFor="let guest of guests">
        <mat-expansion-panel-header> 
          <mat-panel-title>
            Travel Request - {{guest.$mtcDisplayName}} <a class="edit-link" tabindex="0" *ngIf="!isRegComplete" (click)="editGuestTravel(guest)" (keydown.enter)="editGuestTravel(guest)">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
            <a class="edit-link" tabindex="0" *ngIf="isRegComplete" (click)="editGuestTravel(guest)" (keydown.enter)="editGuestTravel(guest)">{{ 'copy.label.SUMMARY.editlocked'| copy | async }}</a>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <span class="form-summary-item" *ngIf="guest.TravelType === this.Constants.TRAVEL_TYPES.PRE_REG">{{ 'copy.label.SUMMARY.alreadybooked'| copy | async }}</span>
        <span class="form-summary-item" *ngIf="guest.TravelType === this.Constants.TRAVEL_TYPES.DRIVE">{{ 'copy.label.SUMMARY.drive'| copy | async }}</span>
        <div *ngIf="guest.TravelType === this.Constants.TRAVEL_TYPES.OWN_AIR" [innerHTML]='"copy.html.ownair" | copy | async'></div>
        <div *ngIf="guest.TravelType === this.Constants.TRAVEL_TYPES.FLY && isRegComplete" [innerHTML]='"copy.html.RvsMtcAir" | copy | async'></div>
        <app-flightsummary *ngIf="guest.TravelType === this.Constants.TRAVEL_TYPES.FLY && !isRegComplete" [attendee]="guest" [enrollment]="enrollment" [traveltype]="'FLY'"></app-flightsummary>
        <app-flightsummary *ngIf="guest.TravelType === this.Constants.TRAVEL_TYPES.RAIL && !isRegComplete" [attendee]="guest" [enrollment]="enrollment" [traveltype]="'RAIL'"></app-flightsummary>
      </mat-expansion-panel>
    </div>
    <div *ngIf="siteFlowContains('payment') && !isRegComplete && showpayment">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{"copy.label.PAYMENT.heading"|copy|async}} 
            <a class="edit-link" tabindex="0" *ngIf="!isRegComplete" (click)="editPayment()" (keydown.enter)="editPayment()">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
            <a class="edit-link" tabindex="0" *ngIf="isRegComplete" (click)="editPayment()" (keydown.enter)="editPayment()">{{ 'copy.label.SUMMARY.editlocked'| copy | async }}</a>
          </mat-panel-title>
        </mat-expansion-panel-header>
        
        <!--div class="form-summary" style="display: block !important" *ngIf="showHotelGuarantee()">
          <h3 class="w-100">{{"copy.label.HOTEL.guarantee"|copy|async}}</h3>
          <app-credit-card-display *ngIf="hotelPayment && hotelcard" cardType="Hotel"></app-credit-card-display>
        </div>

        <div class="form-summary" style="display: block !important" *ngIf="showAirfareGuarantee()">
          <h3 class="w-100">{{"copy.html.Airfare_Costs.summAirGuarant"|copy|async}}</h3>
          <app-credit-card-display *ngIf="airPayment && airCard" cardType="Air"></app-credit-card-display>
        </div>

        <div class="form-summary" style="display: block !important" *ngIf="attendee.PAXTypeNo==6">
          <h3 class="w-100">{{"copy.html.CCCollection.title"|copy|async}}</h3>
          <app-credit-card-display *ngIf="p6Payment && p6CCard" cardType="CCollection"></app-credit-card-display>
        </div-->
        @for(cckey of getKeys(ccObj) ; track cckey){
          @if(someCCisAllowed(cckey)){
            <div class="form-summary" style="display: block !important">
              <h3 class="w-100">
                {{getCardTitles(cckey)}}
              </h3>
              <app-credit-card-display cardType="{{ccObj[cckey][0]}}"></app-credit-card-display>
            </div>
          }
        }
        
      </mat-expansion-panel>
    </div>
    <div *ngIf="siteFlowContains('activity') && attendee.PAXTypeNo !== 3">

    <mat-expansion-panel [expanded]="true" >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Activity Selection
          <a class="edit-link" tabindex="0" (click)="editSessions()" (keydown.enter)="editSessions()" *ngIf="!isRegComplete">{{ 'copy.label.SUMMARY.edit'| copy | async }}</a>
          <a class="edit-link" tabindex="0" *ngIf="isRegComplete" (click)="editSessions()" (keydown.enter)="editSessions()">{{ 'copy.label.SUMMARY.editlocked'| copy | async }}</a>
        </mat-panel-title>
       

      </mat-expansion-panel-header>
      <activity-summary
      *ngIf="ready"
      [inputJson]="output"
      >
      </activity-summary>
    </mat-expansion-panel>
    </div>


    <div class="button_group d-flex">
      <button id="forward-button" type="submit" class="inputSubmit button button-primary ms-auto" *ngIf="!isSubmitting && !isRegComplete">
        Submit
      </button>
      <button class="inputSubmit button button-primary ms-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
  <div *ngIf="errorMsg">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{"copy.label.SUMMARY.heading"|copy|async}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <h2>{{"copy.label.SUMMARY.error"|copy|async}}</h2>
      <p>{{"copy.label.SUMMARY.errordetails"|copy|async}}</p>
      <p *ngIf="'travelHQ800Num'|copy|async">
        {{"copy.label.CONTACTUS.phone"|copy |async}} {{'travelHQ800Num' |copy |async}}
      </p>
      <p *ngIf="'travelHQIntlNum'|copy|async">
        {{"copy.label.CONTACTUS.phone"|copy|async}} {{'travelHQIntlNum'|copy|async}}
      </p>
      <p>{{"copy.label.CONTACTUS.email2"|copy|async}} <a href="mailto:{{'travelHQEmail'|copy|async}}">{{'travelHQEmail'|copy|async}}</a>
      </p>
      <p>{{"copy.label.CONTACTUS.hours"|copy|async}} {{'programSupportHours'|copy|async}}</p>
      <button (click)="errorMsg=undefined">Dismiss</button>
      <!-- <pre>REMOVE THIS BEFORE PROD: <br/>{{enrollment | json}}</pre> -->
    </mat-expansion-panel>
  </div>
</div>
